import conn from "@/store/utils/connection";
import layananApi from "@/store/utils/api-route/layananApi";
import resulter from "@/store/utils/resulter";
import state from "./state"

const actions = {
	async fetchListLayananKonsumen({commit}, payload) {
		try {
			let query = {
				idkonsumen: payload.idcustomer,
				kadaluarsa : payload.kedaluarsa ? 0 : 1,
			}
			const res = await conn.get(layananApi.list.konsumen, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListLayananKonsumen", res.data);
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	},
	async fetchListLayananOwner({commit}, key) {
		try {
			let query = {
				key: key,
			}
			const res = await conn.get(layananApi.list.owner, query)
			if (!res.data) {
				throw(res)
			}
			if (res.data.status) {
				commit("setListLayananOwner", res.data);
				return resulter.successResult()
			} else {
				return resulter.errorResult(res.data.msg)
			}
		} catch (e) {
			return resulter.errorResult(e)
		}
	}
}

export default actions